import React from 'react'

const ReflectionPromptName = ({
    reflectionPrompt = {}
}) => {
    return (
        <React.Fragment>
            {reflectionPrompt.name}
        </React.Fragment>
    )
}

export default ReflectionPromptName